import * as React from 'react';
import { UnitGroupInterface } from './shared';
import { Header, Tab, Form, Modal, Icon } from 'semantic-ui-react';
import ConfigurationsInput from 'src/components/inputs/ConfigurationsInput';
import UnitSensorRenameInput from 'src/components/inputs/UnitSensorRenaming';
import ClientOptions from  'src/container/Client/ClientOptions';
import './UnitGroupEdit.scss';

interface UnitGroupEditProps {
    fromObject: Partial<UnitGroupInterface>;
    resolveRow: (unitGroup?: UnitGroupInterface) => any;
    rejectRow: (err?: Error | { isNormal: boolean, typedId: number }) => any;
    isNew?: boolean;
}

export default class UnitGroupEdit extends React.Component<
    UnitGroupEditProps, 
    any
> {
    resolveRow?: (unitGroup?: UnitGroupInterface) => any;
    rejectRow?: (err?: any) => any;
    
    constructor(props: UnitGroupEditProps) {
        super(props);
        const { resolveRow, rejectRow, fromObject } = props;

        this.resolveRow = resolveRow;
        this.rejectRow = rejectRow;
        
        this.state = { 
            ...fromObject,
            unitSensorRenaming: fromObject.unitSensorRenaming || [],
            configurations: fromObject.configurations || [],
        };
    }

    render() {
        const changeHandler = this.handleChange.bind(this);
        const submitHandler = this.handleSubmit.bind(this);
        const panes = [
            { menuItem: 'Details', render: this.renderDefault.bind(this, this.state, changeHandler) },
            { menuItem: 'Configurations', render: this.renderConfigurations.bind(this, this.state, changeHandler)  }
        ];
        return(
            <Modal 
                closeIcon
                size="fullscreen"
                open={true}
                onClose={this.handleClose.bind(this)}
                className="standard-padding center-margin tb-margin"
                style={{
                    marginTop: 10, 
                    marginLeft: 'auto', 
                    marginRight: 'auto',
                    padding: '21px',
                    boxSizing: 'content-box',
                    overflowY: 'scroll'
                }}
                dimmer="inverted"
                closeOnDimmerClick={true}
            >
                <Modal.Header>Editing UnitGroup {this.state.name}</Modal.Header>
                <Form 
                    onSubmit={submitHandler}
                >
                    <Modal.Content>
                        <Modal.Description className="top-margin">
                            <Tab panes={panes} />

                        </Modal.Description>
                            
                    </Modal.Content>
                    <Modal.Actions>
                        <Form.Button primary float="right" className="top-margin">
                            Submit <Icon name="chevron right"/>
                        </Form.Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        );
    }

    renderDefault ( 
        { 
            alias, 
            priority, 
            name, 
            clientId, 
            unitSensorRenaming, 
            refreshRate,
            isAlwaysOnline
        }: any,
        changeHandler: any
    ) {
        return (
            <Tab.Pane>
                <Form.Field>
                    <label>Name</label>
                    <Form.Input 
                        placeholder="Name" 
                        name="name" 
                        defaultValue={name} 
                        onChange={changeHandler} 
                    />
                </Form.Field>

                <Form.Field>
                    <label>Client</label>
                    <ClientOptions 
                        search
                        name="clientId"
                        defaultValue={clientId}
                        onChange={changeHandler}
                    />
                </Form.Field>

                <Form.Field>
                    <label>Priority</label>
                    <Form.Input 
                        placeholder="0" 
                        name="priority" 
                        defaultValue={priority} 
                        onChange={changeHandler} 
                    />
                </Form.Field>
                <Form.Field>
                    <label>Unit Sensor Renames</label>
                    
                    <UnitSensorRenameInput
                        name="unitSensorRenaming"
                        onChange={changeHandler}
                        initialValue={unitSensorRenaming || []}
                    />
                </Form.Field>
                <Form.Field>
                    <label>Refresh Rate (sec)</label>
                    <Form.Input 
                        type="number"
                        min="0"
                        step="1"
                        placeholder="Refresh Rate (sec)" 
                        name="refreshRate" 
                        defaultValue={refreshRate} 
                        onChange={changeHandler} 
                    />
                </Form.Field>
                <Form.Field>        
                    <br/>
                    <label>Is always Online?</label>
                    <Form.Checkbox 
                        toggle 
                        name="isAlwaysOnline" 
                        defaultChecked={isAlwaysOnline}
                        onChange={this.handleChecked.bind(this)} 
                    />
                </Form.Field>
            </Tab.Pane>
        );
    }

    renderConfigurations({ configurations }: any, changeHandler: any ) {
        return (
            <Tab.Pane>
                <Header>Configurations</Header>
                <Form.Field>
                    <ConfigurationsInput
                        name="configurations"
                        onChange={changeHandler}
                        initialValue={configurations || []}
                    />
                </Form.Field>
            </Tab.Pane>
        );
    }

    handleChange(
        e: any, 
        { 
            name, value 
        }: {
            name: string, 
            value: any
        }
    ) {
        this.setState({ [name]: value });
    }

    handleSubmit = (event: any) => {
        if (event.keyCode !== 13) {
            this.resolveRow(this.state as  any);
        }
    }

    handleClose = () => {
        this.rejectRow({ isNormal: true, typedId: this.state.typedId});
    }

    handleChecked (e: any, {checked, name}: any) {
        this.setState({
            [name] : checked
        });
    }
}


// WEBPACK FOOTER //
// ./src/container/UnitGroup/UnitGroupEdit.tsx